export default "__VITE_ASSET__f28bb6e4__"